import React, { useEffect, useState, useContext } from "react";
import {
  Grid,
  Button,
  Card,
  CardContent,
  Typography,
  CardMedia,
  TextField,
  CircularProgress,
  createTheme,
  ThemeProvider,
  Avatar,
} from "@material-ui/core";
import { ApptContext, InitialApptObj, InitialSlotsObj, Provider,EMRConfig } from "../../../../../../store"; //FB 8215
import useStyles from "../../../../../../css/styles_PE";
import { GetProviders } from "../../../../../../api/PE_API";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@mui/lab";
import { InsertPPLogs } from "../../../../../../api";

// Update log
// FB  6192   02/06/2023  DK  Added for provider workflow
// FB  7143   09/28/2023  GA  Orady - Update the map link to the correct one
// FB  8215   02/01/2024  GA  Portal - Provider images are wrong
// FB  8796   06/23/2024  KI  Auto selecting location and provider if we have only one data
// FB  9379   09/04/2024  KI  Appointment is not showing when default facility is selected in portal


export default function ProviderComponent(props: any) {
  const { state, dispatch } = useContext(ApptContext);
  const [open, setOpen] = useState(false);
  const [providers, setProviders] = useState<Provider[]>([]);
  const [selectedprovider, SetSelectedProvider] = useState<Provider>(state.Provider);
  const [websiteID, setWebsiteID] = useState(0);//FB 8215
  const loading = open && providers.length === 0;
  const styles = useStyles();
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
      action: {
        selected: "#8BD0DB",
        hover: "#5DBDCD",
      },
    },
  });
  const navigate = useNavigate();

  useEffect(() => {
    //FB 8215 Begin
    let data = sessionStorage.getItem("EMRConfig");
    if(data!=null){
    let emrConfig = JSON.parse(data) as EMRConfig;
    setWebsiteID(emrConfig.WebsiteID);
    }
    //FB 8215 End
    GetProviders(0, state.AppointmentType).then((data: any) => {
      setProviders(data);
	  //FB 8796
      if(data.length == 1){
        SetSelectedProvider(data[0]);
        state.Provider = data[0] as Provider; //FB 9379
      }
    });
  }, []);

  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }

  const handleChange = (event: any, value: any) => {
    if (value != null) {
      SetSelectedProvider(value as Provider);
      state.AppointmentType = state.AppointmentType;
      state.AppointmentFilter = state.AppointmentFilter;
      state.Provider = value as Provider;
      state.Facility = {
        ID: 0,
        Name: "",
        Address: "",
        Phone: "",
        Region: 0,
        GOOGLE_MAPS_LINK:"" //FB 7413
      };
      state.FacilityRegion = {
        ID: 0,
        Name: "",
        State: ""
      }
      state.AppointmentDate = new Date();
      state.Duration = 0;
      state.SlotDetails = InitialSlotsObj;
      state.Appointment_N = 0;

      InsertPPLogs(
        "Choose the provider " + value.name,
        window.location.href,
        userName,
        ""
      );
      //ModifyAppointmentObject(state, dispatch);
    } else {
      SetSelectedProvider(InitialApptObj.Provider);
    }
  };

  const handleGoback = () => {
    InsertPPLogs(
      "Clicked on Go Back - by provider",
      window.location.href,
      userName,
      ""
    );
    props.setApptFilter("");
  };

  const handleProceed = () => {
    InsertPPLogs(
      "Clicked on Show Schedule - by provider",
      window.location.href,
      userName,
      ""
    );
    navigate("/user/bookappointment/provider/slots");
  };

  const scrollTo = (ref: any) => {
    if (ref) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div ref={scrollTo}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography variant="h6">Please choose the provider</Typography>
        </Grid>
        {/* FB 4794 */}
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <ThemeProvider theme={theme}>
            <Autocomplete
              id="providerlist"
              className={styles.dropdown_nomargin}
              fullWidth
              onChange={handleChange}
              open={open}
              value={selectedprovider}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              getOptionLabel={(option) =>
                option.JobTitle != "" && option.JobTitle != undefined
                  ? option.Name + " (" + option.JobTitle + ")"
                  : option.Name
              }
              options={providers}
              loading={loading}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              classes={{
                popupIndicator: styles.autocompleteIcon,
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Provider"
                  id="provider"
                  variant="standard"
                  margin="normal"
                  InputProps={{
                    style: { borderColor: "red" },
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        style={{
          display: selectedprovider.ID > 0 ? "flex" : "none",
        }}
      >
        <Grid item xs={12} sm={6} md={5}></Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          lg={5}
          style={{
            display: "flex",
            justifyContent: window.innerWidth <= 768 ? "center" : "",
          }}
        >
          <Card className={styles.provider_Card}>
            <CardMedia style={{ display: "flex", justifyContent: "center" }}>
              <Avatar
                style={{ margin: 5 }}
                className={styles.card_Avatar}
                src={`/Images/Providers/${websiteID}/${selectedprovider.ID}.jpg`} // FB 8215 -Added websiteID to the source path
              />
            </CardMedia>
            <CardContent>
              <Typography variant="h6">
                <b>{selectedprovider.Name}</b>
              </Typography>
              {/* FB 4769 BEGIN */}
              <Typography style={{ fontSize: "smaller" }}>
                {selectedprovider.JobTitle}
              </Typography>
              {/* FB 4769 END */}
              <Typography style={{ fontSize: "smaller" }}>
                {selectedprovider.Bio}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid container spacing={3} className={styles.flexend_Grid}>
        <Grid
          item
          xs={6}
          sm={4}
          md={3}
          lg={2}
          style={{
            display: selectedprovider.ID > 0 ? "block" : "none",
          }}
        >
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={handleProceed}
          >
            Show Schedule
          </Button>
        </Grid>
        <Grid item xs={6} sm={4} md={2} lg={2} className={styles.flexend_Grid}>
          <Button
            id="goBackProvider"
            onClick={handleGoback}
            variant="contained"
            className={styles.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
